<template>
  <main class="product-page">
    <ProductHeader :header="$t('iotPage.header')" :text="$t('iotPage.text')" :shows="true"/>
    <div class="container">
      <div class="mt-10">
        <RegionSwitch @changeRegion="changeRegion" :show-title="true"/>
      </div>

      <div class="table-scroll mb-10">
        <IotTablet :products="productsByRegion"/>
      </div>

      <div class="info w-full mb-8 mt-4">
        <div class="flex mxm-7 flex-wrap">
          <div v-for="item in activeInfo" :key="item.header" class="w-full lg:w-1/4 px-7p mb-6 info-box">
            <div class="bg-white">
              <h5>{{ item.header }}</h5>
              <p>{{ item.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import ProductHeader from "@/components/ProductHeader";
import RegionSwitch from "@/components/product/RegionSwitch";
import IotTablet from "@/components/product/IotTablet";
import {mapState} from "vuex";
import {filterProductsByRegion} from "@/helpers/utils";

export default {
  name: "IotHubView",

  components: {IotTablet, RegionSwitch, ProductHeader},

  data() {
    return {
      activeInfo: this.$i18n.tm('iot'),
      region: {},
    }
  },

  computed: {
    ...mapState('Products', ['products']),

    productsByRegion() {
      return filterProductsByRegion(this.products.filter((product) => product.type === 'iot_hub'), this.region.id);
    }
  },

  methods: {
    changeRegion(region) {
      this.region = region
    }
  },

  watch: {
    '$i18n.locale': function () {
      this.activeInfo = this.$i18n.tm('iot')
    }
  }
}
</script>
